import type { LeadStatus } from '../api/crm';

export interface StageDef {
  key: LeadStatus;
  label: string;
  color: string;
}

const AFFILPLATFORM_STAGES: StageDef[] = [
  { key: 'new', label: 'Nový', color: '#2563eb' },
  { key: 'contacted', label: 'Kontaktován', color: '#d97706' },
  { key: 'qualified', label: 'Kvalifikován', color: '#7c3aed' },
  { key: 'won', label: 'Vyhráno', color: '#0f9d58' },
  { key: 'lost', label: 'Ztraceno', color: '#6b7280' },
  { key: 'rejected', label: 'Neschváleno', color: '#c82b23' },
];

const AFFILMASTER_STAGES: StageDef[] = [
  { key: 'new', label: 'Nový lead', color: '#2563eb' },
  { key: 'contacted', label: 'V jednání', color: '#d97706' },
  { key: 'qualified', label: 'Potvrzený', color: '#0f9d58' },
  { key: 'rejected', label: 'Neschváleno', color: '#c82b23' },
];

export function stagesForSlug(slug: string | null | undefined): StageDef[] {
  return slug === 'affilmaster' ? AFFILMASTER_STAGES : AFFILPLATFORM_STAGES;
}

export function stageDef(slug: string | null | undefined, status: LeadStatus): StageDef {
  const list = stagesForSlug(slug);
  return list.find((s) => s.key === status) ?? { key: status, label: String(status), color: '#6b7280' };
}
